// Node imports
import { Container, SpineBase, IEvent, detectDeviceEnvironmentConstants, dispatcher, ingenuity, IObject, Graphics, delayedCall, killDelayedCall } from "@quest/base-core";
import { SlotConstantsBehavior, SlotEventConstantsBehavior, SoundConstant, View } from "@quest/murka-games-behavior-leopard/dist";
import { ReelPanel, SlotConstants } from "@quest/slot-core";
//game imoports
import { eventDispatchers } from "../Constants/EventDispatchers";
import { gameConstants } from "../Constants/gameConstants";
import { SoundConstantGame } from "../Constants/SoundConstantGame";

export class BaseGameViewGame extends View {
  constructor(json: any) {
    super(json);
    this.visible = false;
    this.getContainerByID("buttonsContainer") && (this.getContainerByID("buttonsContainer").visible = false);
    const reelMask = this.getShapeById("reelMasker") as Graphics;
    reelMask.pivot.set(640,360)
  }
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.PLAY_ONION_EFFECT, this.playOnionAnimation, this);
    dispatcher.on(eventDispatchers.CREATE_WIN_MASK, this.maskWinLayer, this);
    dispatcher.on(eventDispatchers.HIDE_BASE_GAME_PORTRAIT_WIN_MTR, this.hideBaseGamePortraitWinMtr, this);
    dispatcher.on(eventDispatchers.SHOW_BASE_GAME_PORTRAIT_WIN_MTR, this.showBaseGamePortraitWinMtr, this);
    dispatcher.on(eventDispatchers.CREATE_ONION_MASK, this.maskWinLayerForTopOnion, this);
    dispatcher.on(eventDispatchers.REMOVE_ONION_MASK, this.removeMaskForTopOnion, this);
  }
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.PLAY_ONION_EFFECT, this.playOnionAnimation, this);
    dispatcher.off(eventDispatchers.CREATE_WIN_MASK, this.maskWinLayer, this);
    dispatcher.off(eventDispatchers.HIDE_BASE_GAME_PORTRAIT_WIN_MTR, this.hideBaseGamePortraitWinMtr, this);
    dispatcher.off(eventDispatchers.SHOW_BASE_GAME_PORTRAIT_WIN_MTR, this.showBaseGamePortraitWinMtr, this);
    dispatcher.off(eventDispatchers.CREATE_ONION_MASK, this.maskWinLayerForTopOnion, this);
    dispatcher.off(eventDispatchers.REMOVE_ONION_MASK, this.removeMaskForTopOnion, this);
  }

  protected addButtonPanelOnTop() {
    const buttonsContainer = this.getContainerByID("buttonsContainer");
    ingenuity.currentGame.stage.addChild(buttonsContainer);
    const buttonsContainerWidth = buttonsContainer.width;
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.LANDSCAPE) {
      buttonsContainer.pivot.set(ingenuity.configData.width / 2, 0);
      const scale = Math.min((window.innerHeight / ingenuity.configData.height), (window.innerWidth / ingenuity.configData.width));
      buttonsContainer.x = (buttonsContainer.width / 2) + ((window.innerWidth - buttonsContainerWidth) / 2);
      buttonsContainer.y = window.innerHeight - (this.getImageById("Button_Panel_Base").height * scale);
      buttonsContainer.scale.set(scale, scale);
    }
    else if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      buttonsContainer.scale.set(this.portraitPanelSCaling());
      const bottomPanelBgPortrait = this.getImageById("Button_Panel_BasePort");
      bottomPanelBgPortrait && buttonsContainer.pivot.set(bottomPanelBgPortrait.width / 2, bottomPanelBgPortrait.height);
      buttonsContainer.x = window.innerWidth / 2;
      buttonsContainer.y = window.innerHeight;
    }
    this.getContainerByID("portraitButtonsContainer") && ingenuity.currentGame.stage.addChild(this.getContainerByID("portraitButtonsContainer"));
    this.getContainerByID("topPortraitButtonsContainer") && ingenuity.currentGame.stage.addChild(this.getContainerByID("topPortraitButtonsContainer"));
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_SOUND_ON_TOP); 
    dispatcher.fireEvent(eventDispatchers.ADD_TOP_BAR_ON_TOP)   
    dispatcher.fireEvent(eventDispatchers.ADD_TOP_VIEW_ON_TOP); 
  }

  public onShowPortraitButtonpanel() {
    if (this.PortraitplayerMsgContainer && this.portraitButtonsContainer) {
      this.PortraitplayerMsgContainer.visible = true;
      this.PortraitplayerMsgContainer.y = this.getImageById("reelBG").y + this.getShapeById("baseGameResizer").height + SlotConstantsBehavior.PLAYER_MSSG_HEIGHT_SAFEAREA;
      dispatcher.fireEvent(SlotEventConstantsBehavior.ON_CHANGE_PLAYERMSG_PARENT);
      this.changeParent(this.portraitButtonsContainer);
      const portraitButtonContainerBg = this.getShapeById("portraitBackgroundShape");
      this.portraitButtonsContainer.scale.set(this.portraitPanelSCaling());
      let portraitButtonContainerBgHeight = (portraitButtonContainerBg.height * this.portraitButtonsContainer.scale.x);
      let meterPanelHeight = this.getImageById("Button_Panel_BasePort").height * this.getContainerByID("buttonsContainer").scale.x
      this.portraitButtonsContainer.pivot.set(ingenuity.configData.width / 2, 0);
      this.portraitButtonsContainer.x = window.innerWidth / 2;
      this.portraitButtonsContainer.y = window.innerHeight - (portraitButtonContainerBgHeight + meterPanelHeight);
      this.portraitButtonsContainer.alpha = 1;
    }
  }

  protected portraitPanelSCaling(): number {
    const viewHeight = (this.getShapeById("baseGameResizer").height / 2) * this.scale.x;
    let remainingHeight = (window.innerHeight / 2) - viewHeight;
    const portraitButtonContainerBg = this.getShapeById("portraitBackgroundShape");
    let availableScaling = this.scalingAvailable(remainingHeight, portraitButtonContainerBg);
    if (availableScaling > SlotConstantsBehavior.FLOATING_MAX_SCALE) {
      availableScaling = SlotConstantsBehavior.FLOATING_MAX_SCALE;
    }
    return availableScaling;
  }

  public resizeOrientation(e: IEvent) {
    this.storeLandscapeReelSize();//do not change order
    super.resizeOrientation(e);
    if (ingenuity.deviceEnv.getOrientation() !== detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      this.scale.set(ingenuity.deviceEnv.getLandcapeMaxReelScale())
      this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + ((gameConstants.REEL_BOTTOM_SPACE/2)*this.scale.x);
      if(!ingenuity.deviceEnv.isDesktop) {
        this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + ((gameConstants.REEL_BOTTOM_SPACE_LANDSCAPE/2)*this.scale.x);
      }
    }else{
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOP_GAME_LOGO);
    }
  }

  protected storeLandscapeReelSize(): void {
    gameConstants.REEL_WIDTH = this.getShapeById("baseGameLandscapeResizer").width;
    gameConstants.REEL_HEIGHT =this.getShapeById("baseGameLandscapeResizer").height;
  }
  protected portraitHudOnResize() {
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      this.onShowPortraitButtonpanel();
    }
    else {
      if (!ingenuity.deviceEnv.isDesktop) {
        this.onHidePortraitButtonPanel();
      }
    }
  }

  protected resize(e?: IObject): void {
    dispatcher.fireEvent(eventDispatchers.RESIZE_SETTING_PANEL_ON_ORIENTATION);
    super.resize(e);
    this.createReelMasking();
  }
  // Add to hide win meter in portrait
  private hideBaseGamePortraitWinMtr(): void {
    this.getContainerByID("portraitWinMeterContainer").alpha = 0;
  }

  // Add to show win meter in portrait
  private showBaseGamePortraitWinMtr(): void {
    this.getContainerByID("portraitWinMeterContainer").alpha = 1;
  }
  private createReelMasking(): void {
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      this.getContainerByID("gameReelPanelContainer").mask = null;
    } else {
      const reelMask = this.getShapeById("reelMasker") as Graphics;
      if (reelMask) {
        const heightScale = innerHeight / ingenuity.configData.height;
        reelMask.scale.set(heightScale / this.scale.x);
        (this.getContainerByID("gameReelPanelContainer").mask as Graphics) = reelMask;
      }
    }
  }
  protected hideHelpInMobileLandscape():void{
    //
  }
  /**
   * overrided to update reel layering and add reel content in gameReelPanelContainer 
   */
  public setReelView(reelView: ReelPanel, pos?: number, parentId?: string): void {
    this.reelView = reelView;
    const gameReelCont = this.getContainerByID("gameReelPanelContainer")
    gameReelCont.addChildAt(reelView, 1);
    const reelsContainer = this.getContainerByID("reelsContainer");
    gameReelCont.addChildAt(reelsContainer, 2);
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      this.reelView.x = this.reelView.json.portraitX;
      this.reelView.y = this.reelView.json.portraitY;
    }
  }
  // Override to play bonus symbol idle animation in loop after landing animation
  public landingAnimation(data: any) {
    const reelgrid = data[0];
    const reelview = data[1];
    const reelId = data[2];
    for (let i = 0; i < reelgrid[reelId].length; i++) {
      if (this.json.reels.symbolData[reelgrid[reelId][i]].hasLanding) {
        const symbol = reelview.getSymbolByPos(reelId, i);
        const staticSym = symbol.getStatic();
        const animSym: SpineBase = symbol.getAnimation() as SpineBase;
        if (animSym) {
          const staticSymParent = staticSym.parent;
          if (staticSymParent) {
            animSym.visible = true;
            this.getReelView().getAnimReels()[reelId].addChild(animSym);
            animSym.playAnim(symbol.json.animSym.animations.static, false);
            animSym.onComplete.addOnce(() => {
              animSym.playAnim(symbol.json.animSym.animations.landing, false);
              staticSym.visible = false;
              animSym.onComplete.addOnce(() => {
                staticSym.visible = true;
                animSym.visible = false;
              }, this);
            }, this);
          }
        }
      }
    }
  }
  // overide and stop sound temporary as it is thrwoing while  playing
  protected checkAndPlayLandingSounds(evt: IEvent) {
    const scatterSoundId = SoundConstant.SCATTER_LANDING;
    (ingenuity.soundManager as any).playSound(scatterSoundId + evt.data.symbolCount, 1, false, "soundList");
  }

  /**
  * function is over rided to play spine animation for anticipation , initially the animation for anticipation was for sprite
  */
  public showAnticipation(reel: number, callback?: () => void, callbackScope?: any): void {
    const anticipationValueY: number = this.json.anticipationAnim.valueY;
    if (typeof this.anticipationContainer === "undefined") {
      this.anticipationContainer = new Container(this.json, this.game);
      this.anticipationContainer.name = SlotConstants.AnticipationConatiner;
      this.addChild(this.anticipationContainer);
    }
    if (this.anticipationContainer.children.length) {
      this.anticipationContainer.removeChildren();
    }
    if (this.json.anticipationAnim) {
      const anticJson = this.json.anticipationAnim;
      anticJson.id = anticJson.anticipationAnimId;
      const anticipation = this.createSpine(anticJson);
      if (anticipation) {
        anticipation.visible = true;
        this.anticipationContainer.addChild(anticipation);
        this.anticipationContainer.x = this.json.reels.reels[reel].x + this.json.reels.x;
        this.anticipationContainer.y = this.json.reels.reels[reel].y + this.json.reels.y + anticipationValueY;
        this.addChild(this.anticipationContainer);
        anticipation.playAnim(anticJson.anticipationAnimId, true);
      }
    }
  }
  /**
   * to play onion flower throwing animation
   */
  private playOnionAnimation(evt: any) {
    const symbol = this.getReelView().getSymbolByPos(evt.data.reelId, evt.data.symPos);
    const staticSym = symbol.getStatic();
    const animSym: SpineBase = symbol.getAnimation() as SpineBase;
    const staticSymParent = staticSym.parent;
    if (staticSymParent && animSym && staticSym.name === "skull") {
      staticSym.visible = false;
      animSym.visible = true;
      this.getReelView().getAnimReels()[evt.data.reelId].addChild(animSym);
      animSym.playAnim("static", false);
      animSym.onComplete.addOnce(() => {
        (ingenuity.soundManager as any).playSound(SoundConstantGame.SPECIAL_LANDING, 1, false, gameConstants.SOUND_LIST_PRELOAD);
        // (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.SPECIAL_LANDING).onMarkerComplete.addOnce(() => {
        //   (ingenuity.soundManager as any).playSound(SoundConstantGame.SPECIAL_PARTICLE, 1, false, gameConstants.SOUND_LIST_PRELOAD);
        // }, this);
        animSym.playAnim("disable", false);
        delayedCall("disableSPecialSound" + evt.data.reelId + evt.data.symPos, 2500, () => {
          killDelayedCall("disableSPecialSound" + evt.data.reelId + evt.data.symPos);
          (ingenuity.soundManager as any).playSound(SoundConstantGame.SPECIAL_DEACTIVATE, 1, false, gameConstants.SOUND_LIST_PRELOAD);
        })
      }, this);
    }
  }
  protected showAlpha(): void {
    //
  }

  /**
   * to add mask on win presentation layer
   */
  private maskWinLayer(): void {
    const winPanel = this.getWinReelView();
    (winPanel.mask as Graphics) = this.getShapeById("winMasker") as Graphics;
  }
  /**
   * to add mask on win presentation layer
   */
  private maskWinLayerForTopOnion(evt:IEvent): void {
    const winPanel = this.getWinReelView().children[evt.data];
    (winPanel.mask as Graphics) = this.getShapeById("winOnionMasker") as Graphics;
  }
  /**
   * to add mask on win presentation layer
   */
  private removeMaskForTopOnion(evt:IEvent): void {
    const winPanel = this.getWinReelView().children[evt.data];
    (winPanel.mask as Graphics) = null;
  }



  /**Add win mtr on reel */
  protected addPortraitWinBoxOnReel() {
    this.getContainerByID("portraitWinMeterContainer").addChild(this.getContainerByID("winMeterContainer"));
    this.getContainerByID("winMeterContainer").visible = true;
  }
}
